import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { IFestivals } from "../festivalsModel";

export const getAllFestivals = createAsyncThunk(
  "Festivals/FindAllFestivals",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/Festivals/FindAllFestivals`
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Festivals:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const createFestivals = createAsyncThunk(
  "Festivals/InsertFestivals",
  async (FestivalsData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Festivals/InsertFestivals`,
        FestivalsData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating Festivals:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateFestivals = createAsyncThunk(
  "Festivals/UpdateFestivals",
  async (FestivalsData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Festivals/UpdateFestivals`,
        FestivalsData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating Festivals:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteFestivals = createAsyncThunk(
  "Festivals/DeleteFestivals",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Festivals/DeleteFestivals`,
        { ID }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Festivals:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getFestivalsByID = createAsyncThunk(
  "Festivals/FindByIDFestivals",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Festivals/FindByIDFestivals`,
        { ID }
      );
      const result = response.data?.Data as any;
      return {
        ID: result.ID,
        Title: result.Title,
        Description: result.Description,
        IsActive: result?.IsActive ? 1 : 2,
      } as IFestivals;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching Festivals:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getAllActiveFestivals = createAsyncThunk(
  "Festivals/FindAllActiveFestivals",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/Festivals/FindAllActiveFestivals`
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Festivals:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const ActiveInactiveFestivals = createAsyncThunk(
  "Festivals/ActiveInActiveFestivals",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Festivals/ActiveInActiveFestivals`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive Festivals:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
